function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h26v26H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.28 6.46c.667-.245 1.936-.38 3.809-.407 1.887-.027 3.326.14 4.314.503.321.117.553.399.606.736l.616 3.888a.941.941 0 01-.93 1.088H9.067a.941.941 0 01-.794-1.447l2.538-3.984a.941.941 0 01.47-.377z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.732 19.044l6.689.008c.198-1.896 1.813-3.373 3.773-3.373 1.964 0 3.58 1.481 3.775 3.382l1.361.001.125-1.352c-.313-.35-.457-.684-.377-1.036.282-1.238.385-2.48.291-2.977-.527-2.795-1.293-4.701-2.263-5.706-1.05-1.06-2.151-1.8-3.303-2.227-1.747-.649-6.734-.67-8.287-.023-.18.075-.316.134-.434.19-.31.147-.518.28-.721.464-.296.27-.61.67-1.177 1.498-.193.282-1.76 2.625-2.438 3.62-.33.485-.269.459-3.25 1.602-1.779.681-2.69 1.192-2.752 1.535-.089.495-.073 1.277.04 3.038a.756.756 0 01-.008.17.95.95 0 01-.102.292 3.918 3.918 0 01-.097.171c-.062.11-.08.164-.077.228.005.1.019.262.04.484l1.647.002c.207-1.888 1.817-3.356 3.772-3.356 1.958 0 3.57 1.473 3.773 3.365zm2.427-11.86c.647-.197 1.755-.3 3.357-.32 1.644-.021 2.916.11 3.826.4.47.151.83.531.955 1.008.136.521.23.927.282 1.222.046.267.12.796.221 1.595a1.441 1.441 0 01-1.43 1.623h-8.696a1.441 1.441 0 01-1.179-2.27L11.4 7.734c.185-.263.452-.457.76-.55z",
  stroke: "#371447",
  fill: "#64B5F6"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#371447",
  cx: 6,
  cy: 18.767,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#371447",
  cx: 6,
  cy: 18.767,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#371447",
  cx: 20,
  cy: 18.767,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#371447",
  cx: 20,
  cy: 18.767,
  r: 3
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "#371447",
  fill: "#64B5F6",
  x: 7.676,
  y: 11.45,
  width: 2.941,
  height: 1.983,
  rx: 0.882
}));

function SvgVehiclesSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgVehiclesSm;